export const extraInfoValidation = (field, list, info) => {
    var value= info[field.name] ?? ""
    value= value.toString()
    if (field.link) {
        if (!info[field.link.name] || !info[field.link.name].match(field.link.matchPattern)) {
            return null
        }
    }
    if (field.required && value.trim() === "") return `waarde verplicht`
    if (value.trim() === "") return null
    if (field.inList) {
        value.split('|').forEach(val => {
            if (!list.find((item)=>item.value === val)) return `ongeldige waarde`
        })
    } 
    if (field.matchPattern != null && !value.match(field.matchPattern)) return `ongeldige waarde`
    if (field.minValue != null && parseInt(value,10) < field.minValue) return `waarde lager dan ${field.minValue}`
    if (field.maxValue != null && parseInt(value,10) > field.maxValue) return `waarde hoger dan ${field.maxValue}`
    return null
}
